import { tv } from 'tailwind-variants'

export const rewardCardVariants = tv({
  base: [
    'flex flex-col items-center justify-center',
    'w-[72px]',
    'g-1',
    'text-center text-white font-formula',
    'rounded-xl overflow-hidden bg-glass-overlay-light bg-primary-background/80'
  ],
  variants: {
    accentColor: {
      none: '',
      yellow: 'shadow-yellow-top-accent',
      green: 'shadow-green-top-accent',
      blue: 'shadow-blue-top-accent'
    }
  },
  defaultVariants: {
    accentColor: 'none'
  }
})

export const rewardCardLabelVariants = tv({
  base: [
    'z-10',
    'w-full',
    'p-1 pt-2',
    'text-xs font-bold font-formula uppercase [text-shadow:0px_1px_1px_rgba(0,0,0,0.25)]',
    'shadow-white-top-accent-inset'
  ],
  variants: {
    accentColor: {
      none: '',
      yellow: 'bg-yellow',
      green: 'bg-dark-green',
      blue: 'bg-blue'
    }
  },
  defaultVariants: {
    accentColor: 'none'
  }
})

export const rewardCardIconVariants = tv({
  base: [
    'flex items-center justify-center absolute bottom-0 translate-y-1/2 z-20',
    'w-[22px] h-[22px]',
    'rounded-t shadow-white-top-accent-inset'
  ],
  variants: {
    accentColor: {
      none: '',
      yellow: 'bg-yellow',
      green: 'bg-dark-green',
      blue: 'bg-blue'
    }
  },
  defaultVariants: {
    accentColor: 'none'
  }
})
